import React from 'react';
import {
  Container,
  Box,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Snackbar,
  Alert,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

interface BaseProfilePageProps {
  children: React.ReactNode;
  title: string;
  backUrl: string;
  tabValue: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  accentColor: string;
  snackbar: {
    open: boolean;
    message: string;
    severity: 'success' | 'error';
  };
  onSnackbarClose: () => void;
}

const BaseProfilePage: React.FC<BaseProfilePageProps> = ({
  children,
  title,
  backUrl,
  tabValue,
  onTabChange,
  accentColor,
  snackbar,
  onSnackbarClose,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Header showIcons={true} />
      <Container maxWidth="md" sx={{ py: 0, pt: 0 }}>
        {/* 헤더 */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center',
          height: '56px',
          borderBottom: '1px solid #e0e0e0',
          mt: 2
        }}>
          <IconButton 
            onClick={() => navigate(backUrl)} 
            sx={{ 
              ml: -1,
              mr: 1,
              color: '#666666'
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              fontWeight: 600,
              color: '#333333'
            }}
          >
            {title}
          </Typography>
        </Box>

        {/* 탭 메뉴 */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={tabValue} 
            onChange={onTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              minHeight: '44px',
              '& .MuiTab-root': {
                fontSize: '15px',
                fontWeight: 500,
                minHeight: '44px',
                color: '#666666',
                textTransform: 'none',
                py: 0,
                minWidth: 'auto',
                px: 2
              },
              '& .Mui-selected': {
                color: `${accentColor} !important`,
                fontWeight: 600
              },
              '& .MuiTabs-indicator': {
                backgroundColor: accentColor,
                height: '2px'
              },
              '& .MuiTabs-scrollButtons': {
                '&.Mui-disabled': {
                  opacity: 0.3
                }
              }
            }}
          >
            <Tab label="회원정보 수정" />
            <Tab label="로그아웃" />
            <Tab label="회원탈퇴" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          {children}
        </TabPanel>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={onSnackbarClose}
        >
          <Alert
            onClose={onSnackbarClose}
            severity={snackbar.severity}
            sx={{ width: '100%' }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </>
  );
};

export default BaseProfilePage; 